/**
 * Окно выбора организации (multi-organization-login): клиент-компания, за входом которого
 * закреплено несколько организаций, после входа выбирает, в какую зайти. Закрепляет и открепляет
 * организации команда Центрики.
 */
import { Navigate } from 'react-router-dom'
import { useAuth } from '@/app/auth-context'
import { OrganizationPicker } from '@/app/organization-picker'
import { AuthShell } from './auth-shell'
import { Button } from '@/design-system/components/primitives/button'

export function SelectOrganizationPage() {
  const { context, needsOrganization, selectOrganization, logout } = useAuth()
  // Организации выбирает только клиент-компания; остальным здесь делать нечего.
  if (!context || context.user.role !== 'company') return <Navigate to="/" replace />

  return (
    <AuthShell subtitle="Выберите организацию, в которую хотите войти">
      <OrganizationPicker onSelect={selectOrganization} autoSelectSingle={needsOrganization} />
      <div className="mt-5 flex flex-col items-center gap-2 text-center">
        <p className="text-13 text-txt-secondary">
          Вы вошли как <span className="font-medium text-txt">{context.user.email}</span>
        </p>
        <Button variant="secondary" size="sm" onClick={() => void logout()}>
          Выйти
        </Button>
      </div>
    </AuthShell>
  )
}
